<template>
    <div>
        <div v-if="user.tuitioncenter == 2075">
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                    <CRow>
                        <CCol sm="4">
                            <CCard class="bg-white b-20" style="border:none;">
                                <div class="p-3">
                                    <CRow>
                                        <CCol sm="2"><img src="../assets/img/smallicon/view.png" width="28px"/></CCol>
                                        <CCol sm="10"><h3 class="custom-18px-600 m-0">Today Visitor</h3></CCol>
                                        <CCol sm="12">
                                            
                                            <h3 class="custom-40px-600 mt-3">{{todayvisit.count}}</h3>
                                        
                                        <div v-if="todayvisit.direction === 'up'">
                                                <h3 class="text-success custom-12px-400">
                                                    {{todayvisit.compare }}  <img src="../assets/img/smallicon/up.png" width="10px"/>
                                                <label class="custom-12px-400 ml-2 font-color-667085">Compare From yesterday </label>
                                                </h3></div>
                                                <div v-else>
                                                    <h3 class="text-danger custom-12px-400">
                                                    {{todayvisit.compare }}  
                                                    <img  src="../assets/img/smallicon/down.png" width="10px"/> <label class="custom-12px-400 ml-2 font-color-667085">Compare From yesterday </label>
                                                </h3>
                                        </div>
                                        
                                        
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCard>
                        </CCol>
                        <CCol sm="4">
                            <CCard class="bg-white b-20" style="border:none;">
                                <div class="p-3">
                                    <CRow>
                                        <CCol sm="2"><img src="../assets/img/smallicon/calendar.png" width="28px"/></CCol>
                                        <CCol sm="10"><h3 class="custom-18px-600 m-0">This Week Visitor</h3></CCol>
                                        <CCol sm="12">
                                            <h3 class="custom-40px-600 mt-3">{{thisweekvisit.count}}</h3>
                                            <div v-if="lastweekvisit.direction === 'up'">
                                                <h3 class="text-success custom-12px-400">
                                                    {{thisweekvisit.compare }}  <img src="../assets/img/smallicon/up.png" width="10px"/>
                                                <label class="custom-12px-400 ml-2 font-color-667085">Compare From last week </label>
                                                </h3></div>
                                                <div v-else>
                                                    <h3 class="text-danger custom-12px-400">
                                                    {{thisweekvisit.compare }}  
                                                    <img  src="../assets/img/smallicon/down.png" width="10px"/> <label class="custom-12px-400 ml-2 font-color-667085">Compare From last week </label>
                                                </h3>
                                        </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCard>
                        </CCol>
                        <CCol sm="4">
                            <CCard class="bg-white b-20" style="border:none;">
                                <div class="p-3">
                                    <CRow>
                                        <CCol sm="2"><img src="../assets/img/smallicon/calendar.png" width="28px"/></CCol>
                                        <CCol sm="10"><h3 class="custom-18px-600 m-0">Last Week Visitor</h3></CCol>
                                        <CCol sm="12">
                                            <h3 class="custom-40px-600 mt-3">{{lastweekvisit.count}}</h3>
                                            <div v-if="lastweekvisit.direction === 'up'">
                                                <h3 class="text-success custom-12px-400">
                                                    {{lastweekvisit.compare }}  <img src="../assets/img/smallicon/up.png" width="10px"/>
                                                <label class="custom-12px-400 ml-2 font-color-667085">Compare From this week </label>
                                                </h3></div>
                                                <div v-else>
                                                    <h3 class="text-danger custom-12px-400">
                                                    {{lastweekvisit.compare }}  
                                                    <img  src="../assets/img/smallicon/down.png" width="10px"/> <label class="custom-12px-400 ml-2 font-color-667085">Compare From current week </label>
                                                </h3>
                                        </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCard>
                        </CCol>
                        <!-- <CCol sm="4">
                            <CCard class="bg-white b-20" style="border:none;">
                                <div class="p-3">
                                    <CRow>
                                        <CCol sm="2"><img src="../assets/img/smallicon/calendar.png" width="28px"/></CCol>
                                        <CCol sm="10"><h3 class="custom-18px-600 m-0">Last Month</h3></CCol>
                                        <CCol sm="12">
                                            <h3 class="custom-40px-600 mt-3">{{previousmonthvisit.count}}</h3>
                                            <div v-if="previousmonthvisit.direction === 'up'">
                                                <h3 class="text-success custom-12px-400">
                                                    {{previousmonthvisit.compare }}  <img src="../assets/img/smallicon/up.png" width="10px"/>
                                                <label class="custom-12px-400 ml-2 font-color-667085">Compare From last month </label>
                                                </h3></div>
                                                <div v-else>
                                                    <h3 class="text-danger custom-12px-400">
                                                    {{previousmonthvisit.compare }}  
                                                    <img  src="../assets/img/smallicon/down.png" width="10px"/> <label class="custom-12px-400 ml-2 font-color-667085">Compare From current month </label>
                                                </h3>
                                        </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCard>
                        </CCol> -->

                        <CCol sm="12">
                            <CCard class="bg-white b-20" style="border:none;">
                                <canvas id="customBarChart"></canvas>
                            </CCard>
                        </CCol>
                    </CRow>
            </CCol>
        </div>
        <div v-else>
            <div v-if="isPopupError">
                <div class="popup-all1">
                        <!-- Popup content -->
                        <div class="text-center">
                            <img style="max-width: 100px" src="../assets/img/error.png" />
                            <h3 class="custom-32px-500 text-center mt-3 font-color-171717">
                               Ooops!
                            </h3>
                            <h3 class="custom-18px text-center mt-3">
                                You don’t have permission to access this page. Please contact your administrator or check your account settings.
                            </h3>
                        </div>
        
                    </div>
            </div>
            <br /> <br /> <br />
        </div>
      
      
    </div>
</template>


<script>
import Vue from "vue";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'




export default {

    name: "Login",
    components: {
      
        CChartBar,

    },

    data() {
        return {
          
            isPopupVisible2: false,
            list: [],
            user: {},
            todayvisit: {},
            lastweekvisit: {},
            previousmonthvisit: {},
            chart: null,
            chartData: [],
            features:[],
            isPopupError: true,
            thisweekvisit: {}
            
        }
    },
    async mounted() {
        this.SessionUserIdNo();
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                this.SessionUserIdNo();
                this.GetTotalTodayVisitor();
                this.GetThisWeekVisitor();
                this.GetLastWeekVisits();
                this.createBarChart();
                this.GetMonthlyDatas();
                this.$nextTick(() => {
                if (this.chartData.length > 0) {
                    this.createBarChart();
                }
            });
                
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            // Handle the error here
            //this.GoToLogin();
        }

    },

    computed: {
  


    },

    methods: {
        SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
           

            
          }
        });
    },
      
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetTotalTodayVisitor() {
            try {
                const response = await this.$API.get(this.$GetTotalTodayVisitor);
                if (response.status === 200) {
                    this.todayvisit = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetThisWeekVisitor() {
            try {
                const response = await this.$API.get(this.$GetThisWeekVisits);
                if (response.status === 200) {
                    this.thisweekvisit = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async GetLastWeekVisits() {
            try {
                const response = await this.$API.get(this.$GetLastWeekVisits);
                if (response.status === 200) {
                    this.lastweekvisit = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
      
        async GetMonthlyDatas() {
            try {
                const response = await this.$API.get(this.$GetMonthlyChartData);
                if (response.status === 200) {
                    this.chartData = response.data;

                    // Call createBarChart after chartData is populated
                    if (this.chart) {
                        this.chart.destroy(); // Destroy the existing chart
                    }
                    this.createBarChart();
                } else {
                    console.error("Failed to fetch monthly chart data:", response);
                }
            } catch (error) {
                console.error("Error fetching monthly chart data:", error);
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        createBarChart() {
    const canvas = document.getElementById('customBarChart');
    if (!canvas) {
        console.error("Canvas element with id 'customBarChart' not found.");
        return;
    }

    const ctx = canvas.getContext('2d');
    if (!ctx) {
        console.error("Unable to get context for 'customBarChart'.");
        return;
    }

    // Proceed with chart creation
    const gradient = ctx.createLinearGradient(0, 0, 0, ctx.canvas.height);
    gradient.addColorStop(0, '#C69DFF'); // Start color
    gradient.addColorStop(1, '#6587FF'); // End color

    const currentMonth = new Date().toLocaleString('default', { month: 'long' });

    const labels = this.chartData.map(data => data.month);
    const values = this.chartData.map(data => data.value);

    if (values.length === 0) {
        console.error("Chart data is empty. Ensure data is fetched correctly.");
        return;
    }

    // Destroy existing chart if any
    if (this.chart) {
        this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
            labels: labels,
            datasets: [{
                label: 'Monthly Values',
                data: values,
                backgroundColor: labels.map(month =>
                    month === currentMonth ? gradient : '#EAECF0'
                ),
                borderWidth: 1,
            }]
        },
        options: {
            plugins: { tooltip: { enabled: true } },
            scales: {
                x: { beginAtZero: true },
                y: { beginAtZero: true },
            }
        }
    });
},
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },
       
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
       
        
       
    }
    }
</script>

<style>
.custom-chart-bg {
  border-radius: 12px;
  background: var(--jj, linear-gradient(104deg, #C69DFF 0.72%, #6587FF 100%));
}
</style>
